import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import type { IProviderSurveyHistoryItem } from '@brushfire/types'
import { HISTORY_LOAD_MORE_LABEL } from '../lib/history-copy'
import {
  historyCardListSx,
  historyLoadMoreButtonSx,
  historyLoadMoreWrapSx,
} from '../styles/historyStyles'
import { SurveyHistoryCard } from './SurveyHistoryCard'
import { SurveyHistoryEmptyState } from './SurveyHistoryEmptyState'

interface Props {
  items: IProviderSurveyHistoryItem[]
  hasMore: boolean
  isFetchingNextPage: boolean
  onLoadMore: () => void
}

export function SurveyHistoryList({
  items,
  hasMore,
  isFetchingNextPage,
  onLoadMore,
}: Readonly<Props>) {
  if (items.length === 0) {
    return <SurveyHistoryEmptyState />
  }

  return (
    <Box data-testid="history-survey-list">
      <Box sx={historyCardListSx}>
        {items.map((item) => (
          <SurveyHistoryCard key={item.responseId} item={item} />
        ))}
      </Box>

      {hasMore ? (
        <Box sx={historyLoadMoreWrapSx}>
          <Button
            variant="outlined"
            sx={historyLoadMoreButtonSx}
            onClick={onLoadMore}
            disabled={isFetchingNextPage}
            data-testid="history-load-more"
          >
            {isFetchingNextPage ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              HISTORY_LOAD_MORE_LABEL
            )}
          </Button>
        </Box>
      ) : null}
    </Box>
  )
}
